export default (data, pageSize = 'A4', pageOrientation = 'portrait') => {
    // 單據總數與當前序號（無資料則不顯示）
    let receiptCountAndNumText = '';
    if (data.totalReceiptCount && data.currReceiptNumber) {
        receiptCountAndNumText = `（${data.currReceiptNumber} / ${data.totalReceiptCount}）`;
    }

    const def = {
        pageSize,
        pageOrientation,
        defaultStyle: {
            font: 'NotoSansTC',
            fontSize: 10,
        },
        styles: {
            title: {
                fontSize: 22,
                bold: true,
            },
        },
        content: [
            {
                alignment: 'justify',
                columns: [
                    [
                        {
                            text: `請款單-檢附單據 ${receiptCountAndNumText}`,
                            style: 'title',
                            margin: [0, 0, 0, 0],
                        },
                    ],
                ],
            },
            {
                margin: [0, 13, 0, 0],
                table: {
                    widths: [80, '*', 240],
                    heights: 15,
                    body: [
                        ['單據類型', data.type, { text: '備註' }],
                        ['單據日期', data.date, { text: data.note, rowSpan: 6 }],
                        ['單據號碼', data.receiptNumber, ''],
                        ['賣方公司', [
                            { text: data.companyName, margin: [0, 0, 0, 5] },
                            { text: `統一編號：${data.bsn}` },
                            '',
                        ]],
                        ['營業稅', data.tax, ''],
                        ['銷售額(未稅)', data.amtBeforeTax, ''],
                        ['單據總額', { text: `${data.amt} TWD`, bold: true }, ''],
                    ],
                },
            },
            {
                margin: [0, 10, 0, 15],
                table: {
                    widths: ['*'],
                    heights: 450,
                    body: [
                        [{ text: '（無）', margin: [0, 150, 0, 0] }],
                    ],
                },
            },
        ],
    };

    // 圖片 （PDFMaker只能處理圖片，無法處理 PDF 檔案）
    if (data.fileUrl) {
        const fileExt = data.fileUrl.split('.').pop()?.toLowerCase(); // 副檔名
        const imageExtList = ['png', 'jpg', 'jpeg', 'gif']; // 可接受的副檔名
        if (imageExtList.includes(fileExt)) {
            // 插入到表格中的單據欄位
            def.content[2].table.body[0][0] = {
                image: data.base64,
                fit: [450, 450],
                alignment: 'center',
            };
        } else if (fileExt === 'pdf') {
            let pdfEmbedMessage = '';
            if (data.embedPdfStatus === 'SUCCESS') {
                pdfEmbedMessage = '（PDF檔內容檢附於下一頁）';
            }
            if (data.embedPdfStatus === 'ERROR_ENCRYPT') {
                pdfEmbedMessage = '（此PDF檔為加密格式，無法合併列印，請自行另外列印。或改以截圖方式重新檢附。）';
            }
            if (data.embedPdfStatus === 'ERROR_UNKNOWN') {
                pdfEmbedMessage = '（此PDF檔無法合併列印，請自行另外列印。或改以截圖方式重新檢附。）';
            }
            def.content[2].table.body[0][0] = { text: pdfEmbedMessage, margin: [0, 150, 0, 0] };
        }
    }

    return def;
};
